import React, { useState } from "react";
import {
  Segment,
  Input,
  Button,
  Link,
  Form,
  Label,
  Checkbox,
  Grid,
  Icon,
} from "semantic-ui-react";
import AdminApi from "../utils/AdminApi";

const ScoringConstantControl = (props) => {
  // pass in settings from props?
  // track mit_fresh_auto, target_num, admit teams, nep threshold
  const [mitFreshAuto, setMitFreshAuto] = useState(false);
  const [nepAuto, setNepAuto] = useState(false);
  const [targetNum, setTargetNum] = useState(1000);
  const [admitTeams, setAdmitTeams] = useState(true);
  const [nepThresh, setNepThresh] = useState(3);
  const [nepEmails, setNepEmails] = useState([]);
  const [tempEmails, setTempEmails] = useState("");

  const handleNepEmails = (emails) => {
    const splitEmails = emails.split(" ").filter((email) => email !== "");
    setNepEmails(nepEmails.concat(splitEmails));
    setTempEmails("");
  };

  const removeNep = (nep) => {
    const updatedEmails = nepEmails.filter((email) => email !== nep);
    setNepEmails(updatedEmails);
  };

  const clearNepEmails = () => {
    setNepEmails([]);
  };

  const handleDownload = () => {
    AdminApi.loadRawScore()
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "raw_scores.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading raw scores:", error);
        alert("Failed to download raw scores CSV");
      });
  };

  const handleScoringSave = () => {
    AdminApi.loadAppResult()
      .then((response) => {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "application_results.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      })
      .catch((error) => {
        console.error("Error downloading application results:", error);
        alert("Failed to download application results CSV");
      });
  };

  return (
    // todo make this a form mb?? also add data validation for nep thresh
    // and hook up w settings to store these things
    <Segment>
      <Grid columns={3} divided>
        <Grid.Row verticalAlign="middle">
          <Grid.Column>
            <Input
              label="Target Number of Admits"
              type="text"
              value={targetNum}
              onChange={(event) => setTargetNum(event.target.value)}
            />
            <br /> <br />
            <Input
              label="Nep Admit Threshold"
              type="text"
              value={nepThresh}
              onChange={(event) => setNepThresh(event.target.value)}
            />
          </Grid.Column>
          <Grid.Column textAlign="left">
            <Checkbox
              label="Admit Teams"
              defaultChecked={admitTeams}
              toggle
              onChange={(event, data) => {
                setAdmitTeams(data.checked);
              }}
            />
            <br /> <br />
            <Checkbox
              label="Admit MIT First Years"
              defaultChecked={mitFreshAuto}
              toggle
              onChange={(event, data) => {
                setMitFreshAuto(data.checked);
              }}
            />
            <br /> <br />
            <Checkbox
              label="Admit Neps"
              defaultChecked={nepAuto}
              toggle
              onChange={(event, data) => {
                setNepAuto(data.checked);
              }}
            />
          </Grid.Column>
          <Grid.Column>
            {nepEmails.map((email) => {
              return (
                <Label style={{ padding: "5px" }}>
                  {email}
                  <Icon
                    name="delete"
                    style={{ cursor: "pointer" }}
                    onClick={() => removeNep(email)}
                  />
                </Label>
              );
            })}
            <br />
            <br />
            <Input
              label="Nep Emails"
              type="text"
              value={tempEmails}
              onChange={(event) => setTempEmails(event.target.value)}
            />
            <Label style={{ padding: "5px", cursor: "pointer" }}>
              <Icon name="check" onClick={() => handleNepEmails(tempEmails)} />
              <Icon name="trash" onClick={() => clearNepEmails()} />
            </Label>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <br />
      {/* <Button
        color="green"
        as={Link}
        to="/admin/scoring/generate-scores"
        onClick={() => {
          props.downloadAdmitData(
            targetNum,
            admitTeams,
            nepThresh,
            mitFreshAuto,
            nepAuto,
            nepEmails
          );
        }}
      >
        Run Grading
      </Button> */}
      <Button color="green" as={Link} onClick={handleDownload}>
        Raw Score CSV
      </Button>
      <Button
        color="green"
        as={Link}
        onClick={handleScoringSave}
      >
        Save App Scoring
      </Button>
    </Segment>
  );
};

export default ScoringConstantControl;



// WEBPACK FOOTER //
// ./src/components/admin/ScoringConstantControl.js